var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEntypo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.36a2.642 2.642 0 1 0 .003 5.283 2.642 2.642 0 0 0-.004-5.283zm0-3.12a2.64 2.64 0 1 0-.002-5.28 2.64 2.64 0 0 0 .003 5.28m0 11.52a2.64 2.64 0 1 0 0 5.282 2.64 2.64 0 0 0 0-5.282",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntypo);
export default __webpack_public_path__ + "static/media/entypo.0beb11d60d7a1a54e044160a7e5f8758.svg";
export { ForwardRef as ReactComponent };